import { AssetService } from './../../../services/asset.service';
import { SapiEntity } from './../../../services/sapi.service';
import { isValidEmailAddress } from './../../../shared/utils/bb-email-validator.util';
import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'bb-entity-details',
	templateUrl: './bb-entity-details.component.html',
	styleUrls: ['./bb-entity-details.component.scss']
})

export class BbEntityDetailsComponent implements OnInit {
	@Input() hideHeading = false;
	@Input() entity: SapiEntity;
	@Input() theme: 'default' | 'analytics' = 'default';

	importedMediaclipUrl: string;
	sourceUrl: string;
	createdByIsEmailAddress = false;
	updatedByIsEmailAddress = false;

	constructor(
		private assetService: AssetService
	) { }

	ngOnInit() { }

	onEntityInit(entity: any) {
		if (entity.sourceid) {
			this.importedMediaclipUrl = entity.sourceid.startsWith('imported-from:') ? entity.sourceid.replace('imported-from:', '') : '';
		}

		if (entity.src) {
			this.sourceUrl = this.assetService.getAssetUrl(entity);
		}

		this.createdByIsEmailAddress = isValidEmailAddress(entity.createdBy);
		this.updatedByIsEmailAddress = isValidEmailAddress(entity.updatedBy);
	}
}
